// extracted by mini-css-extract-plugin
module.exports = {"container":"ChangePasswordPage__container___J69-_","form":"ChangePasswordPage__form___6asp9","illustration":"ChangePasswordPage__illustration___3v1mM"};